import { MarkdownComponents } from '@magidoc/plugin-svelte-marked';

// The magidoc renderer's defaults, which its own wrapper (which also
// parsed) used to supply. Every user overrides `heading`, so
// the slugger its default heading needs for ids is never called.
export const defaultRenderers = {
	heading: MarkdownComponents.MarkdownHeading,
	blockquote: MarkdownComponents.MarkdownBlockquote,
	list: MarkdownComponents.MarkdownList,
	list_item: MarkdownComponents.MarkdownListItem,
	br: MarkdownComponents.MarkdownBr,
	code: MarkdownComponents.MarkdownCode,
	codespan: MarkdownComponents.MarkdownCodeSpan,
	table: MarkdownComponents.MarkdownTable,
	html: MarkdownComponents.MarkdownHtml,
	paragraph: MarkdownComponents.MarkdownParagraph,
	link: MarkdownComponents.MarkdownLink,
	text: MarkdownComponents.MarkdownText,
	def: MarkdownComponents.MarkdownDfn,
	del: MarkdownComponents.MarkdownDel,
	em: MarkdownComponents.MarkdownEm,
	hr: MarkdownComponents.MarkdownHr,
	strong: MarkdownComponents.MarkdownStrong,
	image: MarkdownComponents.MarkdownImage,
	space: MarkdownComponents.MarkdownSpace,
	escape: MarkdownComponents.MarkdownEscape
};
